import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FactoryService } from '@services/common/factory.service';

@Component({
  standalone: false,
  selector: 'com-btn',
  templateUrl: './com-btn.component.html',
  styleUrls: ['./com-btn.component.scss']
})
export class ComBtnComponent implements OnInit{
  @Input() debounceTime: number = 0;
  @Input() disabled: boolean = false; //disable btn click action
  @Input() actionFlag: boolean = true; //control click btn action
  @Input() label: string;
  @Input() format: boolean = true;
  @Input() toastControl: boolean = false; // toast show, btn can`t click
  @Input() fill: string = 'solid'; // 'solid'/'outline'/'none'
  
  @Output() btnActionEmit = new EventEmitter();

  constructor( 
    public factorySer: FactoryService
  ) {
    this.label = 'Profile.Common.Btn.Confirm';
   }

  async ngOnInit() { }

  public btnAction(): void { 
    if (this.actionFlag) this.btnActionEmit.emit();
  }

}
